import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const missedEarningsAnalysisSlice = createApi({
  reducerPath: "analysis_missed_revenue",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["missed_earnings"],
  endpoints: (build) => ({
    getMissedEarningsSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_earnings/summary`,
        method: "POST",
        headers,
        body: payload,
      }),
    }),
    getMissedEarningsExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_earnings/expand`,
        method: "POST",
        headers,
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetMissedEarningsSummaryQuery,
  useGetMissedEarningsExpandedQuery,
} = missedEarningsAnalysisSlice;
